import * as yup from 'yup';
import { providentBaseInputSchema } from '@/features/Sparten/shared/schema/provident/providentInputSchema';

export const buSchema = providentBaseInputSchema.concat(
  yup.object({
    karenzzeit: yup.string().required().default(''),
    leistungsendalter: yup.number().integer().required().default(67),
    monatlicheRente: yup.number().min(100).max(10000).default(2000).required(),
    niedrigerAnfangsbeitrag: yup.boolean().default(false),
    rentensteigerung: yup.string().required().default(''),
  }),
);
